import { render, staticRenderFns } from "./LmHtmlContent.vue?vue&type=template&id=28e2eec9&"
import script from "./LmHtmlContent.vue?vue&type=script&lang=js&"
export * from "./LmHtmlContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports